module.exports = __webpack_public_path__ + "img/event-banner-01.781913ee.jpg";